import { IAppState } from '../common/state';
import { IGetComparisonDesktopResponseSchema } from 'shared/repositories/offers-comparison/entities/get_comparison_desktop/GetComparisonDesktopResponseSchema';

export const selectComparisonOffers = (state: IAppState): IGetComparisonDesktopResponseSchema | null => {
  return state.comparison;
};
